<script setup lang="ts">
import LandingTitleLayout from '../LandingTitleLayout.vue';
import { type FaqItem } from '../../types';
import { SupportTicketCreateModal } from '@/features/supportTickets';

const props = defineProps<{
  items: FaqItem[];
}>();

const isSupportTicketModalVisible = ref(false);
</script>

<template>
  <div id="faq" class="container">
    <LandingTitleLayout>
      <template #title><span>FAQ</span></template>
    </LandingTitleLayout>

    <div class="accordion-group">
      <AppSpoiler
        v-for="(item, index) in props.items"
        :key="index"
        variant="card"
        class="mb-4"
      >
        <template #header>{{ item.question }}</template>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="item.answer"></div>
      </AppSpoiler>

      <AppButton
        variant="secondary"
        color="dark"
        size="lg"
        fluid
        class="mt-md-4"
        @click="isSupportTicketModalVisible = true"
      >
        Остались вопросы? Напишите
      </AppButton>
    </div>
    <SupportTicketCreateModal
      v-model="isSupportTicketModalVisible"
      @submitted="isSupportTicketModalVisible = false"
    />
  </div>
</template>

<style lang="scss" scoped>
.accordion-group {
  max-width: 789px;
  margin: 0 auto;
}
</style>
